import BillableFilters from "./filters";
import List from "components/list";
import ProjectLayout from "@/modules/work/projects/layout";
import React from "react";
import { useParams } from "react-router-dom";
import { JobCell } from "@/modules/work/billables/cells";
import BillableName from "@/components/billable/cells/name";
import { StatusCell } from "@/components/status/cell";
import TypeCell from "@/components/type/cell";
import { AmountCell } from "@/components/cells/amount";
import { DateCell } from "@/components/date/cell";
import { usePermissions } from "contexts/permission";
import { EmployeeCell } from "components/cell/employee/cell";
import { useProject } from "../context";
import { getEmployeeFields } from "components/user/config";

export default function ProjectBillables() {
  const { project_slug } = useParams();
  const permissions = usePermissions();
  const { id } = useProject()

  const baseFields = [
    "id",
    "name",
    "type",
    "job.name",
    "status",
    "billing_date",
    "due_date",
    {
      job: [
        "id",
        getEmployeeFields("project.account_manager"),
        getEmployeeFields("project.sales_coordinator"),
        "project.project_id",
      ],
    },
  ];

  const canReadAmount = permissions.hasFieldAccess(
    "billables",
    "read",
    "amount",
  );

  const fields = [
    ...baseFields,
    ...(canReadAmount ? ["amount", "currency.name", "adjusted_amount"] : []),
  ];

  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      cell: BillableName,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
    },
    {
      id: "amount",
      header: "Amount",
      accessorKey: "amount",
      cell: AmountCell,
      field: "amount",
    },
    {
      id: "adjusted_amount",
      header: "Adjusted Amount",
      accessorKey: "adjusted_amount",
      cell: AmountCell,
      field: "amount",
    },
    {
      id: "job.name",
      header: "Job",
      accessorKey: "job.name",
      cell: JobCell,
    },
    {
      id: "billing_date",
      header: "Billing Date",
      accessorKey: "billing_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "due_date",
      header: "Due By",
      accessorKey: "due_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "project-account-manager",
      header: "AM",
      accessorKey: "job.project.account_manager",
      cell: EmployeeCell,
    },
    {
      id: "project-sales-coordinator",
      header: "SC",
      accessorKey: "job.project.sales_coordinator",
      cell: EmployeeCell,
    },
  ];

  const defaultFilters = {
    job: { project: { _eq: id } },
    status: { _neq: "archived" },
  };

  if (!id) return null;
  return (

    <List
      title="Billables"
      storageKey={project_slug}
      endPoint="billables"
      filters={defaultFilters}
      columns={columns}
      meta={{ fields }}
      sortby="billing_date"
      renderFilters={BillableFilters}
      href={(item) => `/work/billables/${item.id}`}
    />

  );
}
